import { ELanguage } from '@smartshell/ui-kit';

import { LINKS } from 'links';
import { TLocalesKeys } from 'localization';
import { ETheme } from 'theme';

import { TFeature } from './interfaces';
import {
  activeClientsDarkUrl,
  activeClientsLightUrl,
  gameAccountsDarkUrl,
  gameAccountsLightUrl,
} from './previews';

interface IFeatureConfig {
  title: TLocalesKeys;
  ownerDescription: TLocalesKeys;
  description: TLocalesKeys;
  preview?: Record<ETheme, string>;
  helpLink: Record<ELanguage, string>;
}
export const FEATURES_CONFIG: Partial<Record<TFeature, IFeatureConfig>> = {
  booking: {
    title: 'feature.booking',
    ownerDescription: 'feature.booking.description.owner',
    description: 'feature.booking.description',
    helpLink: LINKS.features['booking'],
  },
  sbp_tinkoff: {
    title: 'sbp',
    ownerDescription: 'feature.sbp.description',
    description: 'feature.sbp.description',
    helpLink: LINKS.features['sbp_tinkoff'],
  },
  combos: {
    title: 'feature.combos',
    ownerDescription: 'feature.combos.description.owner',
    description: 'feature.combos.description',
    helpLink: LINKS.features['combos'],
  },
  bonus_cash: {
    title: 'feature.bonus',
    ownerDescription: 'feature.bonus.description.owner',
    description: 'feature.bonus.description',
    helpLink: LINKS.features['bonus_cash'],
  },
  game_accounts_widget: {
    title: 'feature.applications.accounts',
    ownerDescription: 'feature.applications.accounts.description.owner',
    description: 'feature.applications.accounts.description',
    preview: {
      [ETheme.LIGHT]: gameAccountsLightUrl,
      [ETheme.DARK]: gameAccountsDarkUrl,
    },
    helpLink: LINKS.features['game_accounts_widget'],
  },
  activity_rating: {
    title: 'feature.clients.active',
    ownerDescription: 'feature.clients.active.description.owner',
    description: 'feature.clients.active.description',
    preview: {
      [ETheme.LIGHT]: activeClientsLightUrl,
      [ETheme.DARK]: activeClientsDarkUrl,
    },
    helpLink: LINKS.features['activity_rating'],
  },
  club_news: {
    title: 'permission.name.news_manage',
    ownerDescription: 'features.news.description',
    description: 'features.news.description',
    helpLink: LINKS.features['club_news'],
  },
  copy_settings: {
    title: 'settings.copy.modal.title',
    description: 'feature.unavailable',
    ownerDescription: 'feature.unavailable',
    helpLink: LINKS.features['copy_settings'],
  },
};

type TFeatureTextMap = {
  [P in TFeature]?: Record<ELanguage, string>;
};

export const LINKS_MAP: TFeatureTextMap = {
  cash_orders: LINKS['cash_orders'],
  stock_refill: LINKS['stock_refill'],
  user_history: LINKS['user_history'],
  user_comments: LINKS['user_comments'],
  discounts: LINKS['discounts'],
  base_reports: LINKS['base_reports'],
  work_shift_reports: LINKS['work_shift_reports'],
  auto_per_minute: LINKS['auto_per_minute'],
  pc_disk_hide: LINKS['pc_disk_hide'],
  autostart: LINKS['autostart'],
  telegram_notify: LINKS['telegram_notify'],
  bonus_cash: LINKS['bonus_cash'],
  booking: LINKS['booking'],
  cash_box: LINKS['cash_box'],
  deposit_cashback: LINKS['deposit_cashback'],
  achievements: LINKS['achievements'],
  ai_tariffs: LINKS['ai_tariffs'],
  self_host_change: LINKS['self_host_change'],
  holiday_tariffs: LINKS['holiday_tariffs'],
  visits_report: LINKS['visits_report'],
  usage_report: LINKS['usage_report'],
  sales_report: LINKS['sales_report'],
  user_report: LINKS['user_report'],
  customizable_permissions: LINKS['customizable_permissions'],
  smart_bonus: LINKS['smart_bonus'],
  post_payments: LINKS['post_payments'],
  copy_settings: LINKS.features['copy_settings'],
};
